import { useEffect, useRef } from 'react';

type PollingOptions = {
  intervalMs?: number;
  enabled?: boolean;
  runOnStart?: boolean;
};

const usePolling = (task: () => void | Promise<void>, deps: unknown[], options: PollingOptions = {}) => {
  const { intervalMs = 15000, enabled = true, runOnStart = true } = options;
  const taskRef = useRef(task);
  const inFlightRef = useRef(false);

  useEffect(() => {
    taskRef.current = task;
  }, [task]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    let cancelled = false;

    const run = async () => {
      if (cancelled || inFlightRef.current || document.hidden) {
        return;
      }
      inFlightRef.current = true;
      try {
        await taskRef.current();
      } finally {
        inFlightRef.current = false;
      }
    };

    if (runOnStart) {
      run();
    }

    const handle = window.setInterval(run, intervalMs);

    return () => {
      cancelled = true;
      window.clearInterval(handle);
    };
  }, [...deps, enabled, intervalMs, runOnStart]);
};

export default usePolling;
